<script>
  let {
    assetsPath = '/',
    onAiMounted = () => {},
    onArtboardChange = () => {},
  } = $props();
  import { onMount, untrack } from 'svelte';
  let aiBox;
  let aiBoxWidth = $state(undefined);
  let allArtboards = $state([]);
  let activeArtboard = $state(undefined);
  onMount(() => {
    allArtboards = Array.from(aiBox.querySelectorAll('.g-artboard'));
    onAiMounted();
  });
  $effect(() => {
    if (aiBoxWidth) {
      const currentArtboard = allArtboards.filter((artboard) => {
        const minWidth = parseFloat(artboard.dataset.minWidth);
        const maxWidth = parseFloat(artboard.dataset.maxWidth) || Infinity;
        return minWidth <= aiBoxWidth && maxWidth >= aiBoxWidth;
      })[0];
      if (currentArtboard?.id !== activeArtboard?.id) {
        activeArtboard = untrack(() => currentArtboard);
        onArtboardChange(activeArtboard);
      }
    }
  });
</script>

<div
  id="g-sequence4-box"
  class="ai2svelte"
  bind:this={aiBox}
  bind:clientWidth={aiBoxWidth}
>
  <!-- Artboard: xs -->
  <div
    id="g-sequence4-xs"
    class="g-artboard"
    style="max-width: 509px;aspect-ratio: 0.31900423569147;"
    data-aspect-ratio="0.319"
    data-min-width="0"
    data-max-width="509"
  >
    <div
      id="g-sequence4-xs-img"
      class="g-sequence4-xs-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/sequence4-xs.jpg);"
      loading="lazy"
    ></div>
    <div
      id="g-ai0-1"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:1.4055%;margin-top:-8.5px;left:77.7868%;margin-left:-26.5px;width:53px;"
    >
      <p class="g-pstyle0">00:14</p>
    </div>
    <div
      id="g-ai0-2"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:2.9079%;margin-top:-9.1px;left:12.6511%;width:176px;"
    >
      <p class="g-pstyle1">ICE agent 1 draws his gun</p>
    </div>
    <div
      id="g-ai0-3"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:20.0624%;margin-top:-8.5px;left:77.6515%;margin-left:-26.5px;width:53px;"
    >
      <p class="g-pstyle0">00:15</p>
    </div>
    <div
      id="g-ai0-4"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:21.5648%;margin-top:-9.1px;left:24.3407%;width:147px;"
    >
      <p class="g-pstyle1">Gun pointed at Good</p>
    </div>
    <div
      id="g-ai0-5"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:34.4216%;margin-top:-9.1px;left:33.0179%;width:181px;"
    >
      <p class="g-pstyle1">Wheel pointed to the right</p>
    </div>
    <div
      id="g-ai0-6"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:38.9127%;margin-top:-8.5px;left:77.6515%;margin-left:-26.5px;width:53px;"
    >
      <p class="g-pstyle0">00:15</p>
    </div>
    <div
      id="g-ai0-7"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:39.9673%;margin-top:-18.4px;left:13.31%;width:161px;"
    >
      <p class="g-pstyle2">First shot fired through</p>
      <p class="g-pstyle2">the windshield.</p>
    </div>
    <div
      id="g-ai0-8"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:54.8059%;margin-top:-17.9px;left:33.7269%;width:161px;"
    >
      <p class="g-pstyle1">
        <span class="g-cstyle0">ICE agent 1</span>&rsquo;s legs are to
      </p>
      <p class="g-pstyle2">the side of the vehicle.</p>
    </div>
    <div
      id="g-ai0-9"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:60.083%;margin-top:-8.5px;left:77.6515%;margin-left:-26.5px;width:53px;"
    >
      <p class="g-pstyle0">00:15</p>
    </div>
    <div
      id="g-ai0-10"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:70.9062%;margin-top:-18.5px;left:23.5025%;width:172px;"
    >
      <p class="g-pstyle2">Second shot is fired from</p>
      <p class="g-pstyle2">the side of the vehicle.</p>
    </div>
    <div
      id="g-ai0-11"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:81.3499%;margin-top:-8.5px;left:77.6515%;margin-left:-26.5px;width:53px;"
    >
      <p class="g-pstyle0">00:16</p>
    </div>
    <div
      id="g-ai0-12"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:83.6256%;margin-top:-9.1px;left:31.5598%;margin-left:-42px;width:84px;"
    >
      <p class="g-pstyle3">Third shot</p>
    </div>
  </div>
  <!-- Artboard: sm -->
  <div
    id="g-sequence4-sm"
    class="g-artboard"
    style="min-width: 510px;max-width: 659px;aspect-ratio: 0.92043835838184;"
    data-aspect-ratio="0.92"
    data-min-width="510"
    data-max-width="659"
  >
    <div
      id="g-sequence4-sm-img"
      class="g-sequence4-sm-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/sequence4-sm.jpg);"
      loading="lazy"
    ></div>
    <div
      id="g-ai1-1"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:2.6241%;margin-top:-8.5px;left:43.7058%;margin-left:-26.5px;width:53px;"
    >
      <p class="g-pstyle0">00:14</p>
    </div>
    <div
      id="g-ai1-2"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:2.6241%;margin-top:-8.5px;left:95.2773%;margin-left:-26.5px;width:53px;"
    >
      <p class="g-pstyle0">00:15</p>
    </div>
    <div
      id="g-ai1-3"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:5.429%;margin-top:-9.1px;left:1.5591%;width:176px;"
    >
      <p class="g-pstyle1">ICE agent 1 draws his gun</p>
    </div>
    <div
      id="g-ai1-4"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:5.429%;margin-top:-9.1px;left:60.782%;width:147px;"
    >
      <p class="g-pstyle1">Gun pointed at Good</p>
    </div>
    <div
      id="g-ai1-5"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:29.613%;margin-top:-9.1px;left:66.3967%;width:181px;"
    >
      <p class="g-pstyle1">Wheel pointed to the right</p>
    </div>
    <div
      id="g-ai1-6"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:38.3587%;margin-top:-8.5px;left:43.6537%;margin-left:-26.5px;width:53px;"
    >
      <p class="g-pstyle0">00:15</p>
    </div>
    <div
      id="g-ai1-7"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:38.3587%;margin-top:-8.5px;left:86.1198%;margin-left:-26.5px;width:53px;"
    >
      <p class="g-pstyle0">00:15</p>
    </div>
    <div
      id="g-ai1-8"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:40.0273%;margin-top:-14.8px;left:10.7975%;width:161px;"
    >
      <p class="g-pstyle2">First shot fired through</p>
      <p class="g-pstyle2">the windshield.</p>
    </div>
    <div
      id="g-ai1-9"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:54.646%;margin-top:-14.8px;left:58.6483%;width:172px;"
    >
      <p class="g-pstyle2">Second shot is fired from</p>
      <p class="g-pstyle2">the side of the vehicle.</p>
    </div>
    <div
      id="g-ai1-10"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:62.4968%;margin-top:-16.3px;left:20.94%;width:158px;"
    >
      <p class="g-pstyle3">ICE agent 1&rsquo;s legs are to</p>
      <p class="g-pstyle4">the side of the vehicle.</p>
    </div>
    <div
      id="g-ai1-11"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:71.7472%;margin-top:-8.5px;left:64.8259%;margin-left:-26.5px;width:53px;"
    >
      <p class="g-pstyle0">00:16</p>
    </div>
    <div
      id="g-ai1-12"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:75.274%;margin-top:-9.1px;left:41.7706%;margin-left:-42px;width:84px;"
    >
      <p class="g-pstyle5">Third shot</p>
    </div>
  </div>
  <!-- Artboard: md -->
  <div
    id="g-sequence4-md"
    class="g-artboard"
    style="min-width: 660px;max-width: 929px;aspect-ratio: 0.95578111905376;"
    data-aspect-ratio="0.956"
    data-min-width="660"
    data-max-width="929"
  >
    <div
      id="g-sequence4-md-img"
      class="g-sequence4-md-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/sequence4-md.jpg);"
      loading="lazy"
    ></div>
    <div
      id="g-ai2-1"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:2.8416%;margin-top:-9.6px;left:43.7707%;margin-left:-29px;width:58px;"
    >
      <p class="g-pstyle0">00:14</p>
    </div>
    <div
      id="g-ai2-2"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:2.8416%;margin-top:-9.6px;left:93.559%;margin-left:-29px;width:58px;"
    >
      <p class="g-pstyle0">00:15</p>
    </div>
    <div
      id="g-ai2-3"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:5.6716%;margin-top:-10.2px;left:59.8597%;width:165px;"
    >
      <p class="g-pstyle1">Gun pointed at Good</p>
    </div>
    <div
      id="g-ai2-4"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:5.6716%;margin-top:-10.2px;left:2.6838%;width:198px;"
    >
      <p class="g-pstyle1">ICE agent 1 draws his gun</p>
    </div>
    <div
      id="g-ai2-5"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:29.7109%;margin-top:-10.2px;left:65.2802%;width:203px;"
    >
      <p class="g-pstyle1">Wheel pointed to the right</p>
    </div>
    <div
      id="g-ai2-6"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:38.611%;margin-top:-9.6px;left:43.7195%;margin-left:-29px;width:58px;"
    >
      <p class="g-pstyle0">00:15</p>
    </div>
    <div
      id="g-ai2-7"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:38.611%;margin-top:-9.6px;left:84.7181%;margin-left:-29px;width:58px;"
    >
      <p class="g-pstyle0">00:15</p>
    </div>
    <div
      id="g-ai2-8"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:40.3548%;margin-top:-18.7px;left:11.6029%;width:181px;"
    >
      <p class="g-pstyle2">First shot fired through</p>
      <p class="g-pstyle2">the windshield.</p>
    </div>
    <div
      id="g-ai2-9"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:54.9812%;margin-top:-18.7px;left:57.7998%;width:193px;"
    >
      <p class="g-pstyle2">Second shot is fired from</p>
      <p class="g-pstyle2">the side of the vehicle.</p>
    </div>
    <div
      id="g-ai2-10"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:62.8736%;margin-top:-19.2px;left:21.9626%;width:185px;"
    >
      <p class="g-pstyle1">ICE agent 1&rsquo;s legs are to</p>
      <p class="g-pstyle2">the side of the vehicle.</p>
    </div>
    <div
      id="g-ai2-11"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:72.0634%;margin-top:-9.6px;left:64.1603%;margin-left:-29px;width:58px;"
    >
      <p class="g-pstyle0">00:16</p>
    </div>
    <div
      id="g-ai2-12"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:75.4725%;margin-top:-10.2px;left:41.4376%;margin-left:-46px;width:92px;"
    >
      <p class="g-pstyle3">Third shot</p>
    </div>
  </div>
  <!-- Artboard: lg -->
  <div
    id="g-sequence4-lg"
    class="g-artboard"
    style="min-width: 930px;aspect-ratio: 2.02173913043478;"
    data-aspect-ratio="2.022"
    data-min-width="930"
  >
    <div
      id="g-sequence4-lg-img"
      class="g-sequence4-lg-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/sequence4-lg.jpg);"
      loading="lazy"
    ></div>
    <div
      id="g-ai3-1"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:3.3962%;margin-top:-9.6px;left:45.6126%;margin-left:-29px;width:58px;"
    >
      <p class="g-pstyle0">00:14</p>
    </div>
    <div
      id="g-ai3-2"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:3.3962%;margin-top:-9.6px;left:80.9462%;margin-left:-29px;width:58px;"
    >
      <p class="g-pstyle0">00:15</p>
    </div>
    <div
      id="g-ai3-3"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:7.6444%;margin-top:-10.2px;left:16.7766%;width:198px;"
    >
      <p class="g-pstyle1">ICE agent 1 draws his gun</p>
    </div>
    <div
      id="g-ai3-4"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:7.6444%;margin-top:-10.2px;left:57.3532%;width:165px;"
    >
      <p class="g-pstyle1">Gun pointed at Good</p>
    </div>
    <div
      id="g-ai3-5"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:43.9487%;margin-top:-10.2px;left:61.2%;width:203px;"
    >
      <p class="g-pstyle1">Wheel pointed to the right</p>
    </div>
    <div
      id="g-ai3-6"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:57.3093%;margin-top:-9.6px;left:31.2509%;margin-left:-29px;width:58px;"
    >
      <p class="g-pstyle0">00:15</p>
    </div>
    <div
      id="g-ai3-7"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:57.3093%;margin-top:-9.6px;left:60.1316%;margin-left:-29px;width:58px;"
    >
      <p class="g-pstyle0">00:15</p>
    </div>
    <div
      id="g-ai3-8"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:57.3093%;margin-top:-9.6px;left:88.8808%;margin-left:-29px;width:58px;"
    >
      <p class="g-pstyle0">00:16</p>
    </div>
    <div
      id="g-ai3-9"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:59.7096%;margin-top:-18.7px;left:8.7811%;width:181px;"
    >
      <p class="g-pstyle2">First shot fired through</p>
      <p class="g-pstyle2">the windshield.</p>
    </div>
    <div
      id="g-ai3-10"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:62.427%;margin-top:-10.2px;left:73.0775%;margin-left:-46px;width:92px;"
    >
      <p class="g-pstyle3">Third shot</p>
    </div>
    <div
      id="g-ai3-11"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:81.6661%;margin-top:-18.7px;left:41.3508%;width:193px;"
    >
      <p class="g-pstyle2">Second shot is fired from</p>
      <p class="g-pstyle2">the side of the vehicle.</p>
    </div>
    <div
      id="g-ai3-12"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:93.7313%;margin-top:-19.2px;left:16.1331%;width:185px;"
    >
      <p class="g-pstyle1">ICE agent 1&rsquo;s legs are to</p>
      <p class="g-pstyle2">the side of the vehicle.</p>
    </div>
  </div>
</div>

<!-- End ai2svelte - 2026-01-08 17:33 -->

<!-- Generated by ai2svelte v0.123.1 - 2026-01-08 17:33 -->
<!-- ai file: sequence4.ai -->
<style lang="scss">
  #g-sequence4-box {
    container-type: inline-size;
    container-name: g-sequence4-box;
  }
  #g-sequence4-box,
  #g-sequence4-box .g-artboard {
    margin: 0 auto;
  }
  #g-sequence4-box p {
    margin: 0;
  }
  #g-sequence4-box .g-aiAbs {
    position: absolute;
  }
  #g-sequence4-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-sequence4-box .g-aiSymbol {
    position: absolute;
    box-sizing: border-box;
  }
  #g-sequence4-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-sequence4-box.g-aiPointText p {
    white-space: nowrap;
  }
  #g-sequence4-box {
    width: 100%;
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-sequence4-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-sequence4-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) and (max-width: 929px) {
      #g-sequence4-md {
        display: block !important;
      }
    }
    @container (min-width:930px) {
      #g-sequence4-lg {
        display: block !important;
      }
    }
  }
  #g-sequence4-xs {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-sequence4-xs p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 18px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(255, 212, 48);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-sequence4-xs .g-pstyle0 {
    font-weight: 500;
    line-height: 16px;
    height: 16px;
    font-size: 13px;
    text-align: center;
    color: rgb(255, 255, 255);
  }
  #g-sequence4-xs .g-pstyle1 {
    font-weight: 700;
    line-height: 17px;
    height: 17px;
  }
  #g-sequence4-xs .g-pstyle2 {
    font-weight: 700;
    height: 18px;
  }
  #g-sequence4-xs .g-pstyle3 {
    font-weight: 700;
    line-height: 17px;
    height: 17px;
    text-align: center;
  }
  #g-sequence4-xs .g-cstyle0 {
    letter-spacing: -0.02em;
  }
  #g-sequence4-sm {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-sequence4-sm p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 14px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(255, 212, 48);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-sequence4-sm .g-pstyle0 {
    font-weight: 500;
    line-height: 16px;
    height: 16px;
    font-size: 13px;
    text-align: center;
    color: rgb(255, 255, 255);
  }
  #g-sequence4-sm .g-pstyle1 {
    font-weight: 700;
    line-height: 17px;
    height: 17px;
  }
  #g-sequence4-sm .g-pstyle2 {
    font-weight: 700;
    height: 14px;
  }
  #g-sequence4-sm .g-pstyle3 {
    font-weight: 700;
    line-height: 17px;
    height: 17px;
    letter-spacing: -0.02em;
  }
  #g-sequence4-sm .g-pstyle4 {
    font-weight: 700;
    height: 14px;
    letter-spacing: -0.02em;
  }
  #g-sequence4-sm .g-pstyle5 {
    font-weight: 700;
    line-height: 17px;
    height: 17px;
    text-align: center;
  }
  #g-sequence4-md {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-sequence4-md p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 18px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(255, 212, 48);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-sequence4-md .g-pstyle0 {
    font-weight: 500;
    height: 18px;
    font-size: 15px;
    text-align: center;
    color: rgb(255, 255, 255);
  }
  #g-sequence4-md .g-pstyle1 {
    font-weight: 700;
    line-height: 19px;
    height: 19px;
  }
  #g-sequence4-md .g-pstyle2 {
    font-weight: 700;
    height: 18px;
  }
  #g-sequence4-md .g-pstyle3 {
    font-weight: 700;
    line-height: 19px;
    height: 19px;
    text-align: center;
  }
  #g-sequence4-lg {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-sequence4-lg p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 18px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(255, 212, 48);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-sequence4-lg .g-pstyle0 {
    font-weight: 500;
    height: 18px;
    font-size: 15px;
    text-align: center;
    color: rgb(255, 255, 255);
  }
  #g-sequence4-lg .g-pstyle1 {
    font-weight: 700;
    line-height: 19px;
    height: 19px;
  }
  #g-sequence4-lg .g-pstyle2 {
    font-weight: 700;
    height: 18px;
  }
  #g-sequence4-lg .g-pstyle3 {
    font-weight: 700;
    line-height: 19px;
    height: 19px;
    text-align: center;
  }

  /* Custom CSS */
  @mixin shadow-roquefort($clr) {
    text-shadow:
      0 0 2px rgba($clr, 1),
      0 0 2px rgba($clr, 0.8),
      0 0 2px rgba($clr, 0.5);
  }
  .g-boxtext {
    background-color: rgba(34, 34, 34, 0.768627451);
    border-radius: 2px;
    padding: 10px 9px;
  }
  .g-timestamp {
    background-color: rgba(34, 34, 34);
    padding: 1px 3px;
  }
  .g-yellowtext {
    @include shadow-roquefort(#000000);
  }
</style>
